import { mount } from 'svelte'
import MessageList from '../../components/superadmin/MessageList.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('live-stream')
  if (el) {
    mount(
      MessageList,
      {
        target: el,
      })
  }
})
